module.exports = __webpack_public_path__ + "img/mastercard.caf948c5.png";